import type { RoundMember } from "@engine/round/aggregate";

export function memberIsMeanRecommender(member: RoundMember) {
  for (const evaluator of Object.values(member.evaluators)) {
    if (
      evaluator.type === "recommender" &&
      evaluator.meanRecommenderThreshold != null
    ) {
      return true;
    }
  }
  return false;
}
